import { render } from "./taskInfo.vue?vue&type=template&id=ba7cf998"
import script from "./taskInfo.vue?vue&type=script&lang=js"
export * from "./taskInfo.vue?vue&type=script&lang=js"

import "./taskInfo.vue?vue&type=style&index=0&id=ba7cf998&lang=css"

import exportComponent from "/Users/janbergler/NPM/MPM/V3/mpm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__